import { BrowserRouter } from 'react-router-dom'
import { Providers } from '@/components/providers'
import { AppToaster } from '@/components/ui/sonner'
import { AppRouter } from './router'

export default function App() {
  return (
    <BrowserRouter>
      <Providers>
        <AppRouter />
        <AppToaster />
      </Providers>
    </BrowserRouter>
  )
}
